import { useEffect } from 'react';

import { useTrackOnce } from '#src/app/shared/hooks/tracking';

type Options = Readonly<{ skip?: boolean }>;

export function useTrackPageView({ skip = false }: Options = {}): void {
	const trackOnce = useTrackOnce([skip]);

	useEffect(() => {
		if (skip) return;
		void trackOnce('sap_social_view', { status: 'success' });
	}, [skip, trackOnce]);
}
